module.exports = __webpack_public_path__ + "static/media/ic_config_disable.7a173bdb.svg";